"use client";
import type { ReactElement } from "react";
import { CsegmentedpanelItem } from "./CsegmentedpanelItem";
import type {
  CsegmentedpanelPresentation,
  CsegmentedpanelVariantProps,
} from "./csegmentedpanel.types";

interface CsegmentedpanelLayoutProps extends CsegmentedpanelVariantProps {
  readonly presentation: CsegmentedpanelPresentation;
}

export function CsegmentedpanelLayout({
  columns,
  items,
  presentation,
  style,
}: CsegmentedpanelLayoutProps): ReactElement {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        ...presentation.container,
        ...style,
      }}
    >
      {items.map((item) => (
        <CsegmentedpanelItem
          item={item}
          key={item.label}
          presentation={presentation}
        />
      ))}
    </div>
  );
}
